import {
  ChevronLeft,
  Heart,
  Target,
  Shield,
  Users,
  ChevronRight,
} from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { useNavigate } from "react-router-dom";

const AboutBiteBalance = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: Heart,
      title: "Holistic Health",
      description: "Track nutrition, fitness, and wellness in one place",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
    {
      icon: Target,
      title: "Personalized Goals",
      description: "Custom recommendations based on your unique profile",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: Shield,
      title: "Privacy First",
      description: "Your health data is secure and private",
      color: "text-chart-3",
      bgColor: "bg-chart-3/10",
    },
    {
      icon: Users,
      title: "Community Support",
      description: "Join thousands on their wellness journey",
      color: "text-chart-4",
      bgColor: "bg-chart-4/10",
    },
  ];

  return (
    <div className="min-h-screen bg-background pb-8">
      <div className="mx-auto max-w-md space-y-4 p-4">
        {/* Header */}
        <div className="flex items-center pt-2">
          <button
            onClick={() => navigate("/profile")}
            className="rounded-full p-2 transition-colors hover:bg-muted"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <h1 className="ml-2 text-xl font-bold text-foreground">
            About Bite Balance
          </h1>
        </div>

        {/* App Logo/Banner */}
        <Card className="to-chart-1/10 rounded-2xl border-0 bg-gradient-to-br from-primary/10 p-8 text-center shadow-sm">
          <div className="to-chart-1 mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-primary">
            <span className="text-3xl font-bold text-white">BB</span>
          </div>
          <h2 className="mb-2 text-2xl font-bold text-foreground">
            Bite Balance
          </h2>
          <p className="text-sm text-muted-foreground">
            Your Complete Health Companion
          </p>
          <p className="mt-1 text-xs text-muted-foreground">Version 1.0.0</p>
        </Card>

        {/* Mission Statement */}
        <Card className="rounded-2xl border-0 p-5 shadow-sm">
          <h3 className="mb-3 font-semibold text-foreground">Our Mission</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Bite Balance empowers you to take control of your health through
            intelligent tracking, personalized insights, and evidence-based
            recommendations. We believe that sustainable wellness comes from
            understanding your body and making informed choices every day.
          </p>
        </Card>

        {/* Key Features */}
        <div className="space-y-3">
          <h3 className="font-semibold text-foreground">What We Offer</h3>
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} className="rounded-2xl border-0 p-4 shadow-sm">
                <div className="flex items-start gap-4">
                  <div
                    className={`h-12 w-12 rounded-xl ${feature.bgColor} flex flex-shrink-0 items-center justify-center`}
                  >
                    <Icon className={`h-6 w-6 ${feature.color}`} />
                  </div>
                  <div className="flex-1">
                    <h4 className="mb-1 font-semibold text-foreground">
                      {feature.title}
                    </h4>
                    <p className="text-sm text-muted-foreground">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Legal Links */}
        <Card className="overflow-hidden rounded-2xl border-0 shadow-sm">
          <button
            onClick={() => navigate("/profile/terms")}
            className="flex w-full items-center justify-between p-4 text-left transition-colors hover:bg-muted/50"
          >
            <span className="text-sm font-medium text-foreground">
              Terms of Service
            </span>
            <ChevronRight className="h-5 w-5 text-muted-foreground" />
          </button>
          <div className="mx-4 h-px bg-border" />
          <button
            onClick={() => navigate("/profile/privacy-policy")}
            className="flex w-full items-center justify-between p-4 text-left transition-colors hover:bg-muted/50"
          >
            <span className="text-sm font-medium text-foreground">
              Privacy Policy
            </span>
            <ChevronRight className="h-5 w-5 text-muted-foreground" />
          </button>
          <div className="mx-4 h-px bg-border" />
          <button
            onClick={() => navigate("/profile/licenses")}
            className="flex w-full items-center justify-between p-4 text-left transition-colors hover:bg-muted/50"
          >
            <span className="text-sm font-medium text-foreground">
              Licenses
            </span>
            <ChevronRight className="h-5 w-5 text-muted-foreground" />
          </button>
        </Card>

        {/* Copyright */}
        <p className="text-center text-xs text-muted-foreground">
          © 2025 Bite Balance. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default AboutBiteBalance;
